import { Loader } from '@components'
import { authService } from '@utils/auth/authService'
import { setAuthToken } from '@utils/auth/authSlice'
import { withAuth } from 'oidc-react'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

/**
 * Auth guard that gates the app behind OIDC authentication.
 * Syncs the OIDC access token into authService and Redux once available, rendering a full-page loader until the user session is ready.
 *
 * @component
 * @param {Object} props
 * @param {React.ReactNode} props.children - App content to render once authenticated.
 * @param {Object} props.userData - OIDC user data injected by `withAuth`.
 * @returns {JSX.Element}
 */
const PrivateContent = ({ children, userData }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (userData?.access_token) {
      authService.setToken(userData.access_token)
      dispatch(setAuthToken(userData.access_token))
    }
  }, [userData?.access_token, dispatch])

  return userData && !userData.expired ? children : <Loader full />
}

export default withAuth(PrivateContent)
